var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19094",
    "data-name": "Group 19094",
    transform: "translate(-378 -417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_2020bf85e241394953aca514c8b97948",
    "data-name": "2020bf85e241394953aca514c8b97948",
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm4-9H13V8a1,1,0,0,0-2,0v3H8a1,1,0,0,0,0,2h3v3a1,1,0,1,0,2,0V13h3a1,1,0,1,0,0-2Z",
    transform: "translate(376 415)",
    fill: "#314286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2020bf85e241394953aca514c8b97948-2",
    "data-name": "2020bf85e241394953aca514c8b97948",
    d: "M16,11H13V8a1,1,0,0,0-2,0v3H8a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V13h3a1,1,0,0,0,0-2Z",
    transform: "translate(376 415)",
    fill: "#ed3237"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColor);
export default __webpack_public_path__ + "static/media/add-color.c9f63dbf23f78c63a874e60a6562c5f3.svg";
export { ForwardRef as ReactComponent };